import { faUpload } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'

import useStateChildrenStyles from './useStateChildrenStyles'

const Accept = (): React.ReactElement => {
  const { classes, cx } = useStateChildrenStyles()
  return (
    <FontAwesomeIcon
      icon={faUpload}
      className={cx(classes.icon, classes.accept)}
    />
  )
}

export default Accept
